import { format, parseISO } from "date-fns";
import { getPatientName, isNextAppointment } from "./helpers.js";
import { Role } from "./types/practitioner.js";
import "libphonenumber-js/mobile";
const initialPractitionersSelector = (practitioners) => {
  if (!practitioners) {
    return [];
  }
  return practitioners.map(
    ({ firstName, lastName, userName, imageUrl, referenceId, status, practitionerPositions }) => {
      return {
        avatar: {
          firstName,
          lastName,
          userName,
          imageUrl
        },
        practitionerPositions,
        isSelected: status === "ACTIVE",
        // <-- this one will be updated via useState
        id: referenceId,
        active: status === "ACTIVE",
        // <-- this one will NOT be updated via useState and will only be used to indicate "active practitioner"
        hidden: status !== "ACTIVE"
        // <-- this one will be updated via useState
      };
    }
  );
};
const selectedPractitionersSelector = (practitioners) => {
  return practitioners.filter((item) => {
    const hasVisibleRole = item.practitionerPositions.some(
      ({ role }) => [Role.DENTIST, Role.HYGIENIST].includes(role)
    );
    return item.isSelected && !item.hidden && hasVisibleRole;
  }).map((item) => item.id).join(",");
};
const selectedStatusesSelector = (statuses) => {
  return statuses.filter((item) => item.isSelected).map(({ status }) => status).join(",");
};
const patientTodayListSelector = (patientTodayListData, isObfuscated, fallbacks) => {
  try {
    const list = patientTodayListData.map(
      ({
        referenceId,
        patient,
        appointment: {
          appointmentStart,
          appointmentEnd,
          treatment,
          stateInClinicStart,
          stateTreatmentStart,
          stateInTreatmentRoomStart,
          stateWaitingStart,
          stateTreatmentEnd,
          stateControlled,
          stateControlledAccounting,
          state,
          roomReferenceId,
          cancellation,
          cancellationReason,
          colorCode,
          title,
          risky,
          comment,
          appointmentHints
        },
        practitioner: { firstName: practitionerFirstName, lastName: practitionerLastName, threeLetterId },
        patientDocuments: { anamnesis: anamnesisDocument, factoring: factoringDocument },
        activeCode
      }, index, appointmentsList) => {
        var _a, _b;
        const nextAppointmentStart = (_b = (_a = appointmentsList[index + 1]) == null ? void 0 : _a.appointment) == null ? void 0 : _b.appointmentStart;
        const {
          firstName,
          lastName,
          externalId,
          insuranceType,
          insuranceScannedInCurrentQuarter,
          chemistry,
          phoneNumber,
          creditworthinessStatus,
          // needed by creditworthiness tooltip
          creditworthinessAmount,
          // needed by creditworthiness tooltip
          careLevel,
          referenceId: patientReferenceId
        } = patient || {};
        return {
          id: referenceId,
          patientName: getPatientName({ firstName, lastName, externalId }, fallbacks == null ? void 0 : fallbacks.patientNameFallback),
          treatmentTime: `${format(parseISO(appointmentStart), "HH:mm")} - ${format(
            parseISO(appointmentEnd),
            "HH:mm"
          )}`,
          isNext: isNextAppointment(appointmentStart, nextAppointmentStart),
          selectedDay: new Date(appointmentStart),
          treatmentTitle: title || (treatment == null ? void 0 : treatment.name) || "undefined",
          treatmentColor: colorCode,
          isObfuscated,
          practitionerName: `${practitionerFirstName} ${practitionerLastName}`,
          practitionerThreeLetterId: threeLetterId,
          externalReferenceId: externalId,
          insuranceType,
          insuranceScannedInCurrentQuarter,
          appointmentStateDates: {
            stateInClinicStart,
            stateTreatmentStart,
            stateInTreatmentRoomStart,
            stateWaitingStart,
            stateTreatmentEnd,
            stateControlled,
            stateControlledAccounting
          },
          appointmentState: state,
          roomReferenceId,
          appointmentCancelation: cancellation,
          appointmentCancelationReason: cancellationReason,
          chemistry,
          phoneNumber,
          creditworthinessStatus,
          creditworthinessAmount,
          careLevel,
          appointmentStart,
          nextAppointmentStart,
          anamnesisDocument,
          factoringDocument,
          activeCode,
          patientReferenceId,
          isRiskyAppointment: risky ?? false,
          appointmentComment: comment,
          appointmentHints
        };
      }
    );
    return list;
  } catch (error) {
    console.error(error);
    return [];
  }
};
export {
  initialPractitionersSelector,
  patientTodayListSelector,
  selectedPractitionersSelector,
  selectedStatusesSelector
};
